import React from 'react';

// Default value is defined in SpendCubeSettingsContextProvider
export const SpendCubeSettingsContext = React.createContext({});
